<template>
  <v-container fluid class="grey lighten-3">

    <v-row class="inner-content">
      <v-col>
        <SessionsTable />
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
export default {
  name: 'Sessions',

  components: {
    SessionsTable: () => import('@/components/tables/SessionsTable.vue')
  },
}
</script>
